export const API_KEY = "99edf199137b0b5225e073e051845de2";
export const TMDB_BASE_URL = "https://api.themoviedb.org/3";



